import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Zap, Activity } from "lucide-react";
import { useState } from "react";
import { Button } from "../components/ui/button";
import DemoDialog from "./DemoDialog";
import { HERO_IMAGE } from "../data/content";

export default function Hero() {
  const [demoOpen, setDemoOpen] = useState(false);

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center pt-24 pb-16 overflow-hidden bg-grid"
    >
      <div className="absolute inset-0 -z-10">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/ecb87ced-3422-4dca-a44d-a50b775e7ae1/images/5bdc09aa5344bb8155e2f936a4158061428cfd198c15fd7ade87e0f08250d359.png"
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/85 to-slate-950/30" />
        <div className="absolute inset-0 bg-radial-fade" />
      </div>

      <div className="max-w-7xl mx-auto w-full px-6 md:px-10 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 reveal">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-cyan-400/30 bg-cyan-400/5 mb-8">
            <span className="h-1.5 w-1.5 bg-cyan-400 rounded-full pulse-dot" />
            <span className="text-[11px] uppercase tracking-[0.25em] text-cyan-200 font-medium">
              Integrated Security · Since 2011
            </span>
          </div>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl tracking-tighter font-medium text-slate-50 leading-[0.95]">
            Think Smart.
            <br />
            <span className="text-slate-400">Stay</span>{" "}
            <span className="text-cyan-400">Secure.</span>
          </h1>

          <p className="mt-7 max-w-xl text-base md:text-lg text-slate-400 leading-relaxed">
            GenX Technologies engineers integrated surveillance, access control,
            fire safety and automation systems for enterprises, governments and
            mission-critical facilities across India. We secure today for your tomorrow.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link to="/solutions">
              <Button
                data-testid="hero-explore-solutions"
                variant="outline"
                className="bg-transparent border border-white/15 text-slate-100 hover:bg-white/5 hover:text-cyan-300 hover:border-cyan-400/40 rounded-none h-12 px-7 w-full sm:w-auto"
              >
                Explore Solutions
              </Button>
            </Link>
          </div>

          <div className="mt-14 grid grid-cols-3 max-w-md gap-px bg-white/5 border border-white/5">
            {[
              { icon: Activity, label: "24/7 Monitoring" },
              { icon: ShieldCheck, label: "AES-256 Encrypted" },
              { icon: Zap, label: "Certified Hardware" },
            ].map((t) => (
              <div
                key={t.label}
                data-testid={`trust-${t.label.replace(/\s+/g, "-").toLowerCase()}`}
                className="bg-slate-950 px-4 py-4"
              >
                <t.icon className="h-4 w-4 text-cyan-400 mb-2" />
                <div className="text-[11px] uppercase tracking-[0.18em] text-slate-300 font-medium leading-tight">
                  {t.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] border border-white/10 bg-slate-900 overflow-hidden">
            <img
              src={HERO_IMAGE}
              alt="Operator in modern control room"
              className="w-full h-full object-cover opacity-90"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/40 to-transparent" />

            

            <div className="absolute top-3 left-3 h-4 w-4 border-l-2 border-t-2 border-cyan-400" />
            <div className="absolute top-3 right-3 h-4 w-4 border-r-2 border-t-2 border-cyan-400" />
            <div className="absolute bottom-3 left-3 h-4 w-4 border-l-2 border-b-2 border-cyan-400" />
            <div className="absolute bottom-3 right-3 h-4 w-4 border-r-2 border-b-2 border-cyan-400" />
          </div>

          <div className="hidden lg:block absolute -top-12 -right-12 h-40 w-40 border border-cyan-400/10 rounded-full spin-slow pointer-events-none">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 h-2 w-2 bg-cyan-400 rounded-full" />
          </div>
        </div>
      </div>

      <DemoDialog open={demoOpen} onOpenChange={setDemoOpen} />
    </section>
  );
}
